import { css } from 'emotion'
import * as React from 'react'

import { PersonalizedStatus, PersonalizedStatusText, PersonalizedStatusTexts } from 'embed/constants'

const styles = require('./styles.scss')

export interface Props {
  fontFamily: string
  personalizedStatus?: PersonalizedStatus
}

interface PersonalizedStatusData {
  explanation: JSX.Element
  title?: PersonalizedStatusText
}

type GetPersonalizedStatusData = (personalizedStatus?: PersonalizedStatus) => PersonalizedStatusData | null

export const getPersonalizedStatusData: GetPersonalizedStatusData = (personalizedStatus) => {
  switch (personalizedStatus) {
    case PersonalizedStatus.PreApproved:
      return {
        explanation: (
          <p>
            When you see a pre-approved offer, the issuer has determined that you meet certain criteria, based on a soft
            pull of your credit profile. A soft pull has no impact on your credit score. If you apply for this card and
            pass the lender’s verification process, you have about a 90% chance of being approved! <b>Please note:</b>{' '}
            Pre-approval does not guarantee approval. If you complete an application with the issuer, this will result
            in a hard inquiry on your credit report and may impact your credit score.
          </p>
        ),
        title: PersonalizedStatusTexts.preApproved,
      }
    case PersonalizedStatus.PreQualified:
      return {
        explanation: (
          <p>
            When you’re pre-qualified for a credit card offer, based on certain criteria met from a soft pull of your
            credit profile, the issuer has matched you with offers that may best suit your needs. A soft pull of your
            credit has no impact on your credit score. <b>Please note:</b> Although you have a much higher chance of
            approval, pre-qualified does not guarantee approval. If you complete an application with the issuer, this
            will result in a hard inquiry on your credit report and may impact your credit score.
          </p>
        ),
        title: PersonalizedStatusTexts.preQualified,
      }
    default:
      return null
  }
}

const PersonalizedStatusExplanation = ({ fontFamily, personalizedStatus }: Props) => {
  const personalizedStatusData = getPersonalizedStatusData(personalizedStatus)

  if (!personalizedStatusData) {
    return null
  }

  const { explanation, title } = personalizedStatusData

  return (
    <div>
      {title && (
        <h4
          className={css`
            font-family: ${fontFamily};
          `}
        >
          <div className={styles.personalizedStatusExplanation}>{title}</div>
        </h4>
      )}
      {explanation}
    </div>
  )
}

export default PersonalizedStatusExplanation
